import React from 'react';
import { Shield, Mail, Phone, MapPin, Clock, Users, FileText, Lock } from 'lucide-react';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <>
    <Helmet>
                <title>Privacy Policy</title>
              </Helmet>
    <div className="privacy-policy">
      <style jsx>{`
        .privacy-policy {
          min-height: 100vh;
          background: linear-gradient(135deg, #EEEEEE 0%, #F5F5F5 100%);
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #222831;
          line-height: 1.6;
        }

        .header {
          background: linear-gradient(135deg, #222831 0%, #393E46 100%);
          color: #EEEEEE;
          padding: 4rem 0;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .header::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="2" fill="rgba(255,211,105,0.1)"/></svg>');
          background-size: 50px 50px;
          animation: float 20s infinite linear;
        }

        @keyframes float {
          0% { transform: translateY(0px) translateX(0px); }
          50% { transform: translateY(-20px) translateX(10px); }
          100% { transform: translateY(0px) translateX(0px); }
        }

        .header-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          margin: 0 auto;
          padding: 0 2rem;
        }

        .company-name {
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #FFD369;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }

        .company-tagline {
          font-size: 1.2rem;
          margin-bottom: 2rem;
          opacity: 0.9;
        }

        .shield-icon {
          width: 60px;
          height: 60px;
          color: #FFD369;
          margin-bottom: 1rem;
          filter: drop-shadow(0 4px 8px rgba(0,0,0,0.2));
        }

        .container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 3rem 2rem;
        }

        .intro-section {
          background: white;
          border-radius: 20px;
          padding: 3rem;
          margin-bottom: 3rem;
          box-shadow: 0 10px 30px rgba(34, 40, 49, 0.1);
          border-left: 5px solid #FFD369;
          position: relative;
          overflow: hidden;
        }

        .intro-section::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -50%;
          width: 100%;
          height: 200%;
          background: linear-gradient(45deg, transparent, rgba(255, 211, 105, 0.03), transparent);
          transform: rotate(45deg);
        }

        .intro-content {
          position: relative;
          z-index: 2;
        }

        .last-updated {
          background: #FFD369;
          color: #222831;
          padding: 0.5rem 1rem;
          border-radius: 25px;
          font-size: 0.9rem;
          font-weight: 600;
          display: inline-block;
          margin-bottom: 2rem;
        }

        .section {
          background: white;
          border-radius: 15px;
          padding: 2.5rem;
          margin-bottom: 2rem;
          box-shadow: 0 5px 20px rgba(34, 40, 49, 0.08);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border: 1px solid rgba(255, 211, 105, 0.2);
        }

        .section:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(34, 40, 49, 0.12);
        }

        .section-header {
          display: flex;
          align-items: center;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #FFD369;
        }

        .section-icon {
          width: 28px;
          height: 28px;
          color: #FFD369;
          margin-right: 1rem;
          flex-shrink: 0;
        }

        .section-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #222831;
          margin: 0;
        }

        .section-content {
          color: #393E46;
          font-size: 1rem;
        }

        .section-content p {
          margin-bottom: 1rem;
        }

        .section-content ul {
          margin: 1rem 0;
          padding-left: 1.5rem;
        }

        .section-content li {
          margin-bottom: 0.5rem;
          position: relative;
        }

        .section-content li::marker {
          color: #FFD369;
        }

        .highlight-box {
          background: linear-gradient(135deg, #FFD369, #FFE69A);
          color: #222831;
          padding: 1.5rem;
          border-radius: 10px;
          margin: 1.5rem 0;
          font-weight: 500;
          box-shadow: 0 4px 15px rgba(255, 211, 105, 0.3);
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          margin-top: 2rem;
        }

        .contact-item {
          display: flex;
          align-items: center;
          padding: 1rem;
          background: #EEEEEE;
          border-radius: 10px;
          transition: background 0.3s ease;
        }

        .contact-item:hover {
          background: #FFD369;
          color: #222831;
        }

        .contact-icon {
          width: 20px;
          height: 20px;
          margin-right: 0.75rem;
          color: #393E46;
        }

        .contact-item:hover .contact-icon {
          color: #222831;
        }
        @media (max-width: 768px) {
          .company-name {
            font-size: 2rem;
          }
          
          .container {
            padding: 2rem 1rem;
          }
          
          .intro-section,
          .section {
            padding: 2rem;
          }
          
          .section-header {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .section-icon {
            margin-bottom: 0.5rem;
          }
          
          .contact-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <header className="header">
        <div className="header-content">
          <Shield className="shield-icon" />
          <h1 className="company-name">Gladious Constructions</h1>
          <p className="company-tagline">Building Trust Through Transparency</p>
        </div>
      </header>

      <div className="container">
        <section className="intro-section">
          <div className="intro-content">
            <div className="last-updated">Last Updated: June 13, 2025</div>
            <h2 style={{ color: '#222831', fontSize: '2rem', marginBottom: '1rem' }}>
              Privacy Policy
            </h2>
            <p>
              At Gladious Constructions, we are committed to protecting your privacy and ensuring 
              the security of your personal information. This Privacy Policy explains how we collect, 
              use, disclose, and safeguard your information when you visit our website, use our 
              services, or engage with our construction projects.
            </p>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Users className="section-icon" />
            <h3 className="section-title">Information We Collect</h3>
          </div>
          <div className="section-content">
            <p>We may collect the following types of information:</p>
            <ul>
              <li><strong>Personal Information:</strong> Name, email address, phone number, mailing address, and other contact details</li>
              <li><strong>Project Information:</strong> Property details, construction requirements, budget information, and project timelines</li>
              <li><strong>Communication Records:</strong> Records of our communications with you, including emails, phone calls, and meeting notes</li>
              <li><strong>Website Usage Data:</strong> IP address, browser type, device information, and website interaction data</li>
              <li><strong>Financial Information:</strong> Payment details, billing information, and transaction records</li>
            </ul>
            <div className="highlight-box">
              <strong>Important:</strong> We only collect information that is necessary for providing our construction services and maintaining our business relationship with you.
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <FileText className="section-icon" />
            <h3 className="section-title">How We Use Your Information</h3>
          </div>
          <div className="section-content">
            <p>We use your information for the following purposes:</p>
            <ul>
              <li>Providing construction services and project management</li>
              <li>Communicating about your projects, schedules, and updates</li>
              <li>Processing payments and managing invoices</li>
              <li>Improving our services and customer experience</li>
              <li>Complying with legal and regulatory requirements</li>
              <li>Marketing our services (only with your consent)</li>
              <li>Maintaining safety and security standards on construction sites</li>
            </ul>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Lock className="section-icon" />
            <h3 className="section-title">Information Sharing and Disclosure</h3>
          </div>
          <div className="section-content">
            <p>We may share your information in the following circumstances:</p>
            <ul>
              <li><strong>Service Providers:</strong> With contractors, suppliers, and other professionals involved in your project</li>
              <li><strong>Legal Compliance:</strong> When required by law, regulation, or legal process</li>
              <li><strong>Business Partners:</strong> With trusted partners who assist in providing our services</li>
              <li><strong>Safety and Security:</strong> To protect the safety of our workers, clients, and the public</li>
              <li><strong>Business Transfers:</strong> In connection with any merger, acquisition, or sale of assets</li>
            </ul>
            <div className="highlight-box">
              We never sell your personal information to third parties for marketing purposes.
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Shield className="section-icon" />
            <h3 className="section-title">Data Security</h3>
          </div>
          <div className="section-content">
            <p>We implement comprehensive security measures to protect your information:</p>
            <ul>
              <li>Encryption of sensitive data during transmission and storage</li>
              <li>Regular security assessments and updates</li>
              <li>Access controls and employee training on data protection</li>
              <li>Secure physical storage of documents and records</li>
              <li>Regular backup and disaster recovery procedures</li>
            </ul>
            <p>
              While we strive to protect your information, no method of transmission over the internet 
              or electronic storage is 100% secure. We cannot guarantee absolute security but are 
              committed to implementing industry-standard security practices.
            </p>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Clock className="section-icon" />
            <h3 className="section-title">Data Retention</h3>
          </div>
          <div className="section-content">
            <p>We retain your information for the following periods:</p>
            <ul>
              <li><strong>Project Records:</strong> 7 years after project completion (as required by law)</li>
              <li><strong>Financial Records:</strong> 7 years for tax and accounting purposes</li>
              <li><strong>Communication Records:</strong> 3 years after last contact</li>
              <li><strong>Website Data:</strong> 2 years or until you request deletion</li>
              <li><strong>Marketing Data:</strong> Until you unsubscribe or request removal</li>
            </ul>
            <p>
              After these retention periods, we securely delete or anonymize your information 
              unless we are required to retain it for legal or regulatory purposes.
            </p>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Users className="section-icon" />
            <h3 className="section-title">Your Rights</h3>
          </div>
          <div className="section-content">
            <p>You have the following rights regarding your personal information:</p>
            <ul>
              <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
              <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information (subject to legal requirements)</li>
              <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
              <li><strong>Data Portability:</strong> Request your data in a structured, machine-readable format</li>
              <li><strong>Restriction:</strong> Request limitation of processing in certain circumstances</li>
            </ul>
            <div className="highlight-box">
              To exercise any of these rights, please contact us using the information provided below.
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <FileText className="section-icon" />
            <h3 className="section-title">Cookies and Website Technologies</h3>
          </div>
          <div className="section-content">
            <p>Our website uses cookies and similar technologies to:</p>
            <ul>
              <li>Improve website functionality and user experience</li>
              <li>Analyze website traffic and usage patterns</li>
              <li>Remember your preferences and settings</li>
              <li>Provide personalized content and advertisements</li>
            </ul>
            <p>
              You can control cookie preferences through your browser settings. However, 
              disabling certain cookies may limit website functionality.
            </p>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Mail className="section-icon" />
            <h3 className="section-title">Contact Information</h3>
          </div>
          <div className="section-content">
            <p>
              If you have any questions about this Privacy Policy or our data practices, 
              please contact us:
            </p>
            <div className="contact-grid">
              <div className="contact-item">
                <Mail className="contact-icon" />
                <span>privacy@gladiousconstructions.com</span>
              </div>
              <div className="contact-item">
                <Phone className="contact-icon" />
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="contact-item">
                <MapPin className="contact-icon" />
                <span>123 Construction Ave, Builder City, BC 12345</span>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <FileText className="section-icon" />
            <h3 className="section-title">Updates to This Policy</h3>
          </div>
          <div className="section-content">
            <p>
              We may update this Privacy Policy from time to time to reflect changes in our 
              practices, technology, legal requirements, or other factors. We will notify you 
              of any material changes by:
            </p>
            <ul>
              <li>Posting the updated policy on our website</li>
              <li>Sending an email notification to registered users</li>
              <li>Providing notice during your next interaction with our services</li>
            </ul>
            <p>
              Your continued use of our services after any changes indicates your acceptance 
              of the updated Privacy Policy.
            </p>
          </div>
        </section>
      </div>
    </div>
    </>
  );
};

export default PrivacyPolicy;